import { render, staticRenderFns } from "./WindowAreaSelector.vue?vue&type=template&id=0e0ff21c&scoped=true&"
import script from "./WindowAreaSelector.vue?vue&type=script&lang=js&"
export * from "./WindowAreaSelector.vue?vue&type=script&lang=js&"
import style0 from "./WindowAreaSelector.vue?vue&type=style&index=0&id=0e0ff21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ff21c",
  null
  
)

export default component.exports